
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getCreateInteractionActivityDtoFormGroup() {
return new FormGroup({
    interactiontypeId: new FormControl<number | undefined>(2, [Validators.required]),
    containerId: new FormControl<number | undefined>(undefined),
    activitytypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    outcometypeId: new FormControl<number | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined),
    relationType: new FormControl<string | undefined>('', [Validators.required]),
    relationTypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    visibleForCustomer: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
})
;
}
      